const ChatContainerTexts = {
  'components.chatContainer.title': 'Chat',
  'components.chatContainer.messageTextarea.placeholder': 'Type a message',
  'components.chatContainer.loadingMessages': 'Loading message...',
  /* Buttons */
  'components.chatContainer.loadMoreMessagesButton': 'more message',
  /* Messages */
  'components.chatContainer.messages.startVoiceMessageRecordError.title':
    'Mic access permission are block',
  'components.chatContainer.messages.startVoiceMessageRecordError.description':
    'Accept mic access permission and then refresh the page to send audio message.',
};

const ChatContainerMessageTexts = {
  /* ReportMessageModal */
  'components.chatContainer.chatContainerMessage.reportMessageModal.title':
    'Report message',
  'components.chatContainer.chatContainerMessage.reportMessageModal.sendReportButton':
    'Send report',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.label':
    'Report content',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.item1':
    'Sexual content',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.item2':
    'Hateful or abusive content',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.item3':
    'Harmful or dangerous acts',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.item4':
    'Child abuse',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.item5':
    'Promotes terrorism',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.item6':
    'Spam or misleading',
  'components.chatContainer.chatContainerMessage.reportMessageModal.reportReasonRadio.item7':
    'Infringes my rights',

  /* Buttons */
  'components.chatContainer.chatContainerMessage.copyMessageButton': 'Copy',
  'components.chatContainer.chatContainerMessage.reportMessageButton': 'Report',
  'components.chatContainer.chatContainerMessage.deleteMessageButton': 'Remove',
  /* Messages */
  'components.chatContainer.chatContainerMessage.messages.copyMessageToClipboardSuccess.title':
    'Copied!',
};

export default {
  ...ChatContainerTexts,
  ...ChatContainerMessageTexts,
};
